
import searchInput from '../components/SearchInput.vue';
import loanInfo from '../components/LoanInfo.vue';

import Sticky from 'vux/src/components/sticky/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

export default {
components: {
searchInput,
Sticky,
loanInfo,
Divider,
InlineLoading,
LoadMore,
},
data: function () {
return {
searchValue: '',

openId:'',

loanList: [],

pageIndex: 1,
pageSize: 100,
total: 0, //总数
isloading: false,//是否加载数据
scrollLoading: true, //判断是否滚动加载数据
showReflesh: false, //获取数据失败
checkSearch: false, //检查是否搜索过
}
},
created () {
this.openId = window.sessionStorage.getItem("openId");
if (this.openId == null || this.openId == '') {
this.$vux.toast.text("openId为空", 'top');
} else {
this.getUserInfo(this.openId);
}


window.addEventListener('scroll', this.handleScroll, true);
},
methods: {

getUserInfo (openId) {
const url = 'wechat/queryUser.do?openId=' + openId;
const thiss = this;
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {

if (response.data.result.espstatus == null || String(response.data.result.espstatus) === '0') {
thiss.$router.push({path: '/register'});
} else if (String(response.data.result.espstatus) === '1' || String(response.data.result.espstatus) === '3') {
thiss.$router.push({path: '/personInfo'});
} else {
thiss.getList(0);
}
} else {
thiss.$vux.toast.hide();
thiss.$router.push({path: '/register'});
}
}).catch((error) => {
});
},

handleClick () {
if (this.isSearch()){
this.$vux.toast.text("请输入搜索内容");
return;
}
this.checkSearch = true;
this.handleEnter();

},

isSearch () {
if (this.searchValue == '' || this.searchValue == undefined || this.searchValue == null) {
return true;
} else {
return false;
}
},

handleChange (event) {
if (event == '' || event == null || event === undefined) {
return;
}

const keyCode = event.keyCode;
if (keyCode == 8 && this.isSearch() && this.checkSearch) {
this.handleEnter();
this.checkSearch = false;
}
},

handleEnter () {
this.pageIndex = 1;
this.loanList = [];
this.getList(0);

},

getList (length) {

if (this.pageIndex != 1) {
this.isloading = true;
}
const _this = this;
let params={
openId: _this.openId
}
let checkValue=(this.searchValue||'').replace(/,/g,'')
if((/^[0-9]+\.?[0-9]*$/g).test(checkValue)){
console.log(checkValue)
params.applyguasum=Number(checkValue)
}else{
params.productName=this.searchValue
}
this.$axios({
method: 'post',
url: '/wechat/queryMyLoans.do',
data:params,
}).then((response) => {
_this.showReflesh = false;
if (response.data.code === 200) {
_this.loanList =_this.loanList.concat(response.data.result);
_this.isloading = false;
_this.scrollLoading = true;
} else {
}
}).catch(function(err){

_this.isloading = false;
_this.showReflesh = true;
})
},
goDetail (item) {
const projectId = item.PROJECTID;
this.$router.push(`/loanDetail/${projectId}`);
},

handleScroll () {

const scrollHeight = document.documentElement.scrollHeight; 
const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
const clientHeight = document.documentElement.clientHeight;

const height = scrollHeight - scrollTop - clientHeight <= 30;

if (this.scrollLoading && height) {
this.scrollLoading = false;


if (this.loanList.length < this.pageSize) {
return;
}
this.pageIndex = this.pageIndex + 1;
this.getList(0);
}

},

reflesh () {

let tasklength = 0;

if (this.loanList.length < this.pageSize && this.loanList.length > 0) {
tasklength = this.loanList.length;
}
if (this.loanList.length == this.pageSize) {
tasklength = 0;
this.pageIndex += 1;
}
this.getList(tasklength);
},
},
beforeDestroy () {

window.removeEventListener('scroll', this.handleScroll, true);
}
}



// WEBPACK FOOTER //
// ./src/pages/LoanList.vue